import axios from 'axios';
import { useMutation } from 'react-query';
import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';
import { SET_DELIVERY_DATE } from './constants';

export type DeliveryDateReq = {
  loan_application_id: string;
  delivery_date: string;
};

const postDeliveryDate = async (data: DeliveryDateReq) => {
  const { loan_application_id, ...newDeliveryDate } = data;
  const resp = await axios.post(
    `${getBaseApi()}/dealer/application/${loan_application_id}/set_delivery_date`,
    JSON.stringify(newDeliveryDate),
    {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('user_token')}` },
    },
  );
  if (!resp || resp.status !== 200) {
    throw new Error('Error submitting application');
  }

  return resp.data;
};

const usePostDeliveryDate = () => {
  const mutation = useMutation({
    mutationKey: [SET_DELIVERY_DATE],
    mutationFn: postDeliveryDate,
  });

  return {
    postDeliveryDate: mutation.mutate,
    ...mutation,
  };
};

export { usePostDeliveryDate };
